import { GlobalModal } from './GlobalModal';

export class GlobalModalClose extends GlobalModal {
  constructor() {
    super({ name: 'close' });
  }
}
